import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { axios } from "@/client/libs/axios";
import type { ProviderZonesList, CreateProviderZoneDto } from "@reactive-resume/dto";

const updateProviderZones = async (id: string, data: Partial<CreateProviderZoneDto>) => {
  const response = await axios.put(`/provider/zone/${id}`, data);
  return response.data;
};

const updateStatus = async (id: string, data: { isActive: boolean }) => {
  const response = await axios.put(`/provider/zone/${id}`, data);
  return response.data;
};

export const useChgStatus = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: { isActive: boolean } }) =>
      updateStatus(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["providerZones"] });
      queryClient.invalidateQueries({ queryKey: ["providers"] });
    },
  });
};

export const useUpdateProviderZone = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, data }: { id: string; data: Partial<CreateProviderZoneDto> }) =>
      updateProviderZones(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["providerZones"] });
      queryClient.invalidateQueries({ queryKey: ["providers"] });
    },
  });
};
